import React, {useEffect, useMemo, useState} from "react";
import AdminLayout from "@widgets/layout/AdminLayout";
import {editJobApplication, Route} from "@/routing/Router";
import {useParams} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import JobApplicationEditor from "@widgets/jobApplications/editor/JobApplicationEditor";
import {JobApplicationDetails} from "@/data/entities/jobApplication";
import {api} from "@/data/api";

const JobApplication = () => {
    const {jobApplicationId: jobApplicationIdRaw} = useParams();
    const jobApplicationId = Number(jobApplicationIdRaw);
    const route: Route = useMemo(() => editJobApplication(jobApplicationId), [jobApplicationId]);
    const [jobApplication, setJobApplication] = useState<JobApplicationDetails | undefined>(undefined);
    const {data, error} = useQuery({
        queryKey: ["job-application", jobApplicationId],
        queryFn: () => api.jobApplication.getJobApplication(jobApplicationId),
    });


    // Place fetched employee in state
    useEffect(() => {
        if (data !== undefined) {
            setJobApplication(data);
        }
    }, [data]);

    if (error) {
        throw new Error("Cannot load job application");
    }

    return (
        <AdminLayout currentPage={route}>
            <JobApplicationEditor
                route={route}
                jobApplication={jobApplication}
                setJobApplication={setJobApplication}
            />
        </AdminLayout>
    );
};

export default JobApplication;